import React, {Component} from 'react';
import authorize from "./authorize";
const authorizePage = (authority)=>(WrappedComponent)=>{

    return class extends Component {
        state={
            authorized:true
        }
        constructor(props) {
            super(props)
        }
        componentWillMount() {
            if(authority) {
                authorize(authority).then(() => {
                    this.setState({
                        authorized: true
                    })
                }, () => {
                    this.setState({
                        authorized: false
                    })
                })
            }else{
                this.setState({
                    authorized: true
                })
            }
        }
        render() {
            const defaultComponent = <div>您没有权限！</div>
            return (
                this.state.authorized?
                    <WrappedComponent {...this.props}/>:(defaultComponent?defaultComponent:null)
            )
        }
    }
}
export default authorizePage